import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError, map, Observable, of, tap } from 'rxjs';
import { LocalStoreService } from '../../../common/services/storage.service';
import { Router } from '@angular/router';
import { SwalService } from '../../../common/services/swal.service';
import { QuotesService } from './quotes.service';

@Injectable({
    providedIn: 'root'
})
export class ExchangeRateService {
    private http = inject(HttpClient);
    private store = inject(LocalStoreService);
    private router = inject(Router);
    private swal = inject(SwalService);
    private quotesService = inject(QuotesService);

    private rate: number | null = null;
    private rateAvailable = false;

    getUsdRate(): number | null {
        return this.rate;
    }

    isUsdAvailable(): boolean {
        return this.rateAvailable;
    }

    loadRateOnStartup(): Observable<boolean> {
        return this.http.get<{ rateChange: number }>('Currencies/4/RateChange').pipe(
            tap((response) => {
                if (typeof response.rateChange === 'number' && response.rateChange > 0) {
                    this.rate = response.rateChange;
                    this.rateAvailable = true;
                } else {
                    this.handleRateError();
                }
            }),
            map(() => true), // Let app start regardless
            catchError((error) => {
                console.error('Failed to load USD rate', error);
                this.handleRateError();
                return of(true); // Don't block app start
            })
        );
    }

    private handleRateError(): void {
        this.rateAvailable = false;
        this.rate = null;

        // Check if there is an existing quote in session storage
        if (this.store.getSessionItem('currentQuote') || this.quotesService.currentQuote) {
            this.swal.error('Las cotizaciones en USD no están disponibles en este momento.');
            this.quotesService.clearCurrentQuote();
            this.store.removeSessionItem('currentQuote');
            this.router.navigate(['/']);
        }
    }
}
